import { Injectable } from '@angular/core';
import { ToolsService } from '../../tools/tools.service';
import { Base2Service } from '../base2.service';
import * as moment from 'moment';
import { allergens } from 'src/app/consts/allergens';
import { Observable, from, BehaviorSubject } from 'rxjs';
import { FulleStockService } from '../fulle/fulle-stock/fulle-stock.service';
import { BaseclientService } from '../../apiclient/baseclient.service';
import { cloneDeep } from 'lodash';
import { ClientProductsFavoriteService } from '../../apiclient/clientproductsfavorite/clientproductsfavorite.service';
import { LangagesService } from '../../manage/langages/langages.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ProductSuggestionsComponent } from 'src/app/components/dialogs/product-suggestions/product-suggestions.component';
import { MediaObserver } from '@angular/flex-layout';
import { FormulesSuggestionsComponent } from 'src/app/components/dialogs/formules-suggestions/formules-suggestions.component';
import { PanierService } from "../../manage/panier/panier.service";
import { SalemethodService } from "../salemethod/salemethod.service";
import { FulleProduct, Suggestion } from '../fulle/fulle-product/fulle-product.interface';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private obserGetProduct: BehaviorSubject<any> = new BehaviorSubject(null);
  private allergens: any[] = allergens;
  private obserLoaderProductsSuggested: BehaviorSubject<any> = new BehaviorSubject(null);
  private obserLoaderFormulesSuggested: BehaviorSubject<any> = new BehaviorSubject(null);
  private ObserProductTypeformule: BehaviorSubject<any> = new BehaviorSubject(null);
  private ObsersuggestionsEnd: BehaviorSubject<any> = new BehaviorSubject(null);
  public pricePeriods: any = [];
  Mysuggestions: any;

  constructor(
    private base2: Base2Service,
    private tools: ToolsService,
    private stockApi: FulleStockService,
    private baseClient: BaseclientService,
    private ClientProductsFavoriteService: ClientProductsFavoriteService,
    private langServ: LangagesService,
    public translate: TranslateService,
    public dialog: MatDialog,
    public media: MediaObserver
  ) {
  }

  // Return the Observable getobserGetProduct
  getobserGetProduct(): Observable<any> {
    return this.obserGetProduct.asObservable();
  }

  //set for get prodcut
  setobserGetProduct(value?: any): void {
    value = value ? value : null;
    this.obserGetProduct.next(value);
  }

  /**
   * Suggestions
   */

  // Return the Observable LoaderProductsSuggested
  getObserLoaderProductsSuggested(): Observable<any> {
    return this.obserLoaderProductsSuggested.asObservable();
  }

  //set for LoaderProductsSuggested
  setObserLoaderProductsSuggested(value?: any): void {
    value = value ? value : null;
    this.obserLoaderProductsSuggested.next(value);
  }

  // Return the Observable Loader Formules Suggested
  getObserLoaderFormulesSuggested(): Observable<any> {
    return this.obserLoaderFormulesSuggested.asObservable();
  }

  //set for LoaderFormulePSuggested
  setObserLoaderFormulePSuggested(value?: any, close?: any): void {

    let set = {
      value: value ? value : null,
      close: close ? close : null,

    }
    this.obserLoaderFormulesSuggested.next(set);

  }

  // Return the Observable ObserProductTypeformule
  getObserProductTypeformule(): Observable<any> {
    return this.ObserProductTypeformule.asObservable();
  }

  // Return the Observable ObsersuggestionsEnd
  getObsersuggestionsEnd(): Observable<any> {
    return this.ObsersuggestionsEnd.asObservable();
  }

  //set for setObsersuggestionsEnd
  setObsersuggestionsEnd(value?: any): void {
    let value_ = value ? value : null;
    this.ObsersuggestionsEnd.next(value_);
  }

  getValidSlots(dateOrder?: any): Promise<any> {
    const date = dateOrder ? dateOrder : this.tools.getStor("date_order");
    const pos: any = this.tools.getStor("point_of_sale");
    const sm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    const params = {
      pos_id: pos.id,
      sm_id: sm.id,
      date_order: moment(date).format("YYYY-MM-DD"),
      id_merchant: this.tools.getStor("id_merchant")
    }
    return this.baseClient.postBase("getValidSlots", params);
  }

  /**
   * Récupération des périodes de prix
   */
  getPricePeriods(): Observable<any> {
    // Recupération API
    return from(new Promise((resolve) => {
      this.baseClient.postBaseApi("price_periods").then(pricePeriods => {
        this.pricePeriods = pricePeriods;
        resolve(pricePeriods)
      });
    }));
  }

  /**
   * Récupération d'un objet price_period
   */
  searchPricePeriodById(id: number) {
    if (this.pricePeriods.list) {
      for (let currentValue of this.pricePeriods.list) {
        if (currentValue.id === id) {
          return currentValue;
        }
      }
    }
    return null;
  }

  /**
   * Récupération d'un nom price_period
   */
  getPricePeriodName(id: number) {
    let pricePeriod = this.searchPricePeriodById(id)
    if (pricePeriod != null) {
      return pricePeriod.name;
    }
    return "";
  }

  /**
   * @description add stock categories
   * @param {any} products
   */

  addstockCat(products: any): void {

    for (let i = 0; i < products.categories.length; i++) {
      let item = products.categories[i];

      if (item.details.length > 0) {
        for (let j = 0; j < item.details.length; j++) {
          item.details[j].product.stock = this.stockApi.stocks[item.details[j].product.id];

        }
      }
    }
  }

  /**
   * @description Récupère la galerie d'image d'un produit
   * @param {number} productId
   * @return {Promise<any>}
   */
  getGallery(productId: number): Promise<any> {
    return this.base2.getBase("products_gallery/" + productId);
  }


  $_getGallery(productId: number): Promise<any> {

    const params = {
      id_product: productId
    };
    return this.baseClient.postBaseApi("products/gallery", params);
  }


  /**
   * @description Parse le tableau d'id d'allergene du produit en lui ajoutant un nom
   * @param {number[]} prodAllergens
   * @return {any[]} parsedAllergens
   */
  parseAllergens(prodAllergens: any): any[] {

    const parsedAllergens = [];

    if (prodAllergens) {

      for (let i = 0; i < prodAllergens.length; i++) {
        let prodAllergensId = prodAllergens[i];

        for (let j = 0; j < this.allergens.length; j++) {
          let allergens = this.allergens[j];

          if (prodAllergensId === allergens.id) {
            allergens.name = this.translate.instant('allergens.' + allergens.id);

            parsedAllergens.push(allergens);
            break;
          }

        }

      }

    }


    return parsedAllergens;

  }

  getValidTimeTables(pointOfSale: any, saleMethod_id: any): any[] {
    let validTimeTables = pointOfSale.timetables;
    if (pointOfSale.timetables_sm) {
      for (let index = 0; index < pointOfSale.timetables_sm.length; index++) {
        const timeTable = pointOfSale.timetables_sm[index];
        if (timeTable.id_sale_method === saleMethod_id) {
          validTimeTables = timeTable.timetables;
          break;
        }
      }
    }
    return validTimeTables;
  }

  getParamsProducts(smId: any, rubric_id?: any, $limit_from?: any, search?: any) {
    const now = moment();
    const dateOrder = this.tools.getStor("date_order") ? moment(this.tools.getStor("date_order")) : "";
    const hourOrder = this.tools.getStor("hour_order") ? moment(this.tools.getStor("hour_order")) : "";

    let currDay: any;
    let currHour: any;
    let day: any;

    // if une date order
    if (dateOrder) {
      currDay = dateOrder.day();
      currHour = hourOrder ? hourOrder.format("HH:mm:ss") : now.format("HH:mm:ss");
      day = dateOrder.format("YYYY-MM-DD") + ' ' + currHour;
    }

    const lang = this.langServ.getLang();

    const pos: any = this.tools.getStor("point_of_sale");

    let params: any = {
      archive: 0,
      id_sale_method: smId,
      id_point_of_sale: this.tools.getStor("point_of_sale").id,
      with_ht: 1,
      for_sale: 1,
      handle_price_period: 1,
      price_period_day: currDay,
      price_period_hour: currHour,
      language: lang,
      rubric_id: rubric_id,
      limit_from: $limit_from,
      search: search,
      id_webshop: pos ? pos.id_webshop : null,
      price_period_date: day
    }

    return params;
  }

  /**
   * Récupère les produits en fonction de la methode de vente et d'autres parametres
   * @param smId
   * @param $limit_from
   * @param rubric_id
   * @param search
   * @param start
   * @param pricePeriods
   */
  getProducts_(smId: number, $limit_from?: any, rubric_id?: any, search?: any, start?: any, pricePeriods?: any): Promise<any> {
    console.log(" [TYPAGE] smId : ", smId);
    console.log(" [TYPAGE] $limit_from : ", $limit_from);
    console.log(" [TYPAGE] rubric_id : ", rubric_id);
    console.log(" [TYPAGE] search : ", search);
    console.log(" [TYPAGE] start : ", start);
    console.log(" [TYPAGE] pricePeriods : ", pricePeriods);
    if (start)
      this.tools.removeStor("ids_suggestions");
    let params: any = this.getParamsProducts(
      smId,
      rubric_id,
      $limit_from,
      search
    );
    // console.log("product.service - getProducts_ - params : ", params);
    return new Promise(resolve => {
      this.baseClient.postBaseApi('products_rub', params).then(products => {
        // console.log("product.service - getProducts_ - products : ", products);
        // init le stock
        this.parsebasketProd(products, pricePeriods).then(parsedProds => {
          // console.log("product.service - getProducts_ - parsedProds : ", parsedProds);
          /**
           * Ajout de propriétés au produit pour les afficher sur le DOM
           */
          parsedProds.count = products.count;
          parsedProds.num_rows = products.num_rows;
          parsedProds.products_to_display = products.products_to_display;
          parsedProds.next_limit_from = products.next_limit_from;
          parsedProds.displayDay = params.price_period_day; //currday
          parsedProds.displayHour = params.price_period_hour; //currHour
          if (parsedProds.products && parsedProds.products.length > 0) {
            let result = this.suggestions(parsedProds.products);
            if (result && result.length > 0) {
              // get products by suggestions ids
              this.getSuggestionProducts(result).then((products_suggestions: any) => {
                // console.log("product.service - getProducts_ - products_suggestions : ", products_suggestions);

                this.Mysuggestions = products_suggestions.list ? products_suggestions.list : []
                resolve(parsedProds);
              })
            } else {
              resolve(parsedProds);
            }
          } else {
            resolve(parsedProds);
          }
        });
      });
    });
  }

  parsebasketProd(products: any, pricePeriods: any = null): Promise<any> {
    return new Promise(resolve => {
      /**
       * Récupération des priceperiods
       * Récupération des stocks
       forkJoin(
       this.stockApi.getStocks() // On effectue la requete pour récupérer les stocks
       ).subscribe(() => {
      })  */
      const parsedProds = products.list.filter((prod: any) => prod.free_price === 0);
      /**
       * Ajout d'une quantité à 1 par défaut
       * Ajout et set de la proprety price_period à l'objet
       *
       * Si un produit à une price période alors on set le promoflag à true (Qui permettra par la suite d'ajouter une rubrique promo ou non)
       */
      parsedProds.map((p: any) => {
        p.quantity = 1;
        p.price_period = null;
        // Si le produit a un happy hour, on charge l'object happy hour sur l'article
        if (p.prices[0].id_price_period && pricePeriods != null) {
          for (let j = 0; j < pricePeriods.length; j++) {
            if (p.prices[0].id_price_period === pricePeriods[j].id) {
              p.price_period = pricePeriods[j];
              break;
            }
          }
        }

        p.stock = null;

        // init stock si existe
        if (typeof this.stockApi.stocks == 'object') {
          p.stock = this.stockApi.stocks[p.id];
          if (p.categories.length > 0) {
            this.addstockCat(p);
          }
        }
      });

      /**
       * Fin de la promesse
       */
      resolve(
        {
          products: parsedProds
        }
      );
    })
  }

  suggestions(products: FulleProduct[]) {
    const idsSuggestions: number[] = [];
    let uniqueArray: number[] = [];
    let idsSuggestionsLocalstorage = null;
    products.forEach((element: FulleProduct) => {
      // console.log("suggestions - element : ", element)

      if (element.suggestions && element.suggestions.length > 0) {
        element.suggestions.forEach((value: number) => {
          idsSuggestions.push(value);
        });
      }
    });
    // console.log("suggestions - idsSuggestions : ", idsSuggestions)

    const test_1 = this.tools.getStor("ids_suggestions");

    // console.log("suggestions - test_1 : ", test_1)
    if (idsSuggestions && idsSuggestions.length > 0) {
      idsSuggestionsLocalstorage = this.tools.getStor("ids_suggestions");
      console.log("[TYPAGE] idsSuggestionsLocalstorage : ", idsSuggestionsLocalstorage);

      if (idsSuggestionsLocalstorage && idsSuggestionsLocalstorage.length) {
        idsSuggestionsLocalstorage.forEach((element: any) => {
          idsSuggestions.push(element);
        });
      }
    }
    // console.log("suggestions - idsSuggestionsLocalstorage : ", idsSuggestionsLocalstorage)

    const test_2 = this.tools.getStor("ids_suggestions");

    // console.log("suggestions - test_2 : ", test_2)
    if (idsSuggestions && idsSuggestions.length == 0) {
      this.tools.removeStor("ids_suggestions");
    } else {
      uniqueArray = [...new Set(idsSuggestions)];
      this.tools.setStor("ids_suggestions", uniqueArray);
    }
    // console.log("suggestions - idsSuggestions : ", idsSuggestions)

    const test_3 = this.tools.getStor("ids_suggestions");

    // console.log("suggestions - test_3 : ", test_3)
    return uniqueArray;
  }


  /******************
   * Suggestions
   *
   *******************/

  /**
   * @description get Suggestions
   * @param {number} prod
   */
  getSuggestions(prod: any) {

    let currBasket: any = this.tools.getStor(PanierService.TAG_STORAGE);
    let is_webshop_end = 0;
    let quantityProd: any = [];

    if (currBasket && currBasket.length > 0) {
      currBasket.forEach((prod: any) => {
        quantityProd['qte_' + prod.id] = quantityProd['qte_' + prod.id] ? quantityProd['qte_' + prod.id] + prod.quantity : prod.quantity;
      });
    }


    let result: any = [];


    if (prod.suggestions && prod.suggestions.length > 0) {


      prod.suggestions.forEach((element: any) => {


        //get suggest with is_webshop_end==0
        let suggestions = this.Mysuggestions.find((value: any) => (value.id == element && value.is_webshop_end == is_webshop_end));


        if (suggestions && suggestions.products && suggestions.products.length > 0) {


          suggestions['products_to_suggest'] = [];

          suggestions.products.forEach((id_product_sugg: any) => {

            let flag = false;

            //verifier si le produit n'est pas dans le panier

            if (currBasket && currBasket.length > 0) {

              if (quantityProd['qte_' + id_product_sugg] >= quantityProd['qte_' + prod.id]) {
                flag = true;
              }

            }

            if (!flag) {
              suggestions['products_to_suggest'].push(id_product_sugg);
            }

          })


          if (suggestions['products_to_suggest'].length > 0) {
            result.push(suggestions);
          }

        }
      });


    }

    return result;


  }


  /**
   * @description check Products Suggestions End
   * @param {number} merchantClient
   */
  checkProductsSuggestionsEnd(merchantClient?: any) {

    this.getSuggestionsEnd().then((mysuggestions: any) => {

      this.tools.setStor('SuggestionsEnd', true);

      if (mysuggestions && mysuggestions.length > 0) {
        this.setObserLoaderProductsSuggested(true);
        this.checkValidityProductsSuggestions(mysuggestions, merchantClient);
      } else {

        this.setObsersuggestionsEnd("fid");


      }
    })
  }

  /**
   * @description getSuggestions End
   */
  getSuggestionsEnd(): Promise<any> {

    return new Promise(resolve => {

      let idsSuggestionsLocalstorage = this.tools.getStor("ids_suggestions") && this.tools.getStor("ids_suggestions").length > 0 ? this.tools.getStor("ids_suggestions") : null


      let is_webshop_end = 1;
      if (idsSuggestionsLocalstorage) {


        this.getSuggestionProducts(idsSuggestionsLocalstorage).then((products_suggestions: any) => {

          let suggestions_end = [];
          this.Mysuggestions = products_suggestions.list ? products_suggestions.list : []
          suggestions_end = this.Mysuggestions.filter((value: any) => (value.is_webshop_end == is_webshop_end));


          if (suggestions_end && suggestions_end.length > 0) {
            suggestions_end.forEach((element: any) => {
              if (element.products && element.products.length > 0)
                element['products_to_suggest'] = [];
              element.products.forEach((id_product_sugg: any) => {
                element['products_to_suggest'].push(id_product_sugg);
              })
            })


          }

          let currBasket: any = this.tools.getStor(PanierService.TAG_STORAGE);
          if (suggestions_end && currBasket) {


            let quantityProd: any = [];

            currBasket.forEach((prod: any) => {
              quantityProd['qte_' + prod.id] = quantityProd['qte_' + prod.id] ? quantityProd['qte_' + prod.id] + prod.quantity : prod.quantity;
            })


            currBasket.forEach((prod: any) => {


              if (prod.suggestions && prod.suggestions.length > 0) {

                prod.suggestions.forEach((element: any) => {

                  //get suggest with is_webshop_end

                  let suggestions = this.Mysuggestions.find((value: any) => (value.id == element && value.is_webshop_end == is_webshop_end));


                  if (suggestions && suggestions.products && suggestions.products.length > 0) {

                    suggestions['products_to_suggest'] = [];

                    suggestions.products.forEach((id_product_sugg: any) => {

                      let flag = false;

                      if (quantityProd['qte_' + id_product_sugg] >= quantityProd['qte_' + prod.id]) {

                        flag = true;
                      }

                      if (!flag) {
                        suggestions['products_to_suggest'].push(id_product_sugg);
                      }

                    })


                  }

                });


              }
            });


          }


          resolve(suggestions_end);

        })
      } else {
        resolve(null)
      }

    });
  }

  /**
   * @description get Suggestions products
   * @params ids_suggestions
   * @return promise
   */
  getSuggestionProducts(ids_suggestions: any): Promise<any> {
    return new Promise(resolve => {
      let params = {
        ids: ids_suggestions
      }
      this.baseClient.postBaseApi('products_suggestions', params).then(products_suggestions => {
        resolve(products_suggestions);
      })

    })
  }

  /**
   * @description check Products Suggestions first
   * @param {any} prod
   */

  checkProductsSuggestions(prod: any, merchantClient?: any) {

    // prod.quantity==1 &&
    if (prod.suggestions && prod.suggestions.length > 0) {
      //suggestions
      let mysuggestions = this.getSuggestions(prod);

      if (mysuggestions && mysuggestions.length > 0) {
        this.setObserLoaderProductsSuggested(true);
        this.checkValidityProductsSuggestions(mysuggestions, merchantClient);
      }

    }


  }


  /**
   * @description checkValidty des products suggered
   * @param {any} suggestions
   */
  checkValidityProductsSuggestions(suggestions: any, merchantClient?: any) {

    this.getValidProductsSuggestion(suggestions).then(data => {

      // console.log("getValidProductsSuggestion ok");
      // console.log("data");

      this.setObsersuggestionsEnd(false);
      this.setObserLoaderProductsSuggested(false);
      if (data && data.length > 0) {
        this.openSuggestionsProductsDial(data, merchantClient);
      } else {
        this.setObserLoaderProductsSuggested("fid");
      }
    })
  }

  /**
   * @description Ouvre la popup des produits suggerer
   * @param {any} suggestions
   */
  openSuggestionsProductsDial(suggestions: any, merchantClient?: any) {

    const myConf = new MatDialogConfig();
    myConf.data = {
      suggestions: suggestions,
      merchantClient: merchantClient
    };

    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "780px", myConf.height = "100%");


    const myDial = this.dialog.open(ProductSuggestionsComponent, myConf);

    myDial.disableClose = true;

    myDial.afterClosed().subscribe((result) => {

      this.setObsersuggestionsEnd("fid")
    });
  }

  /**
   * @description get Valid Products Suggestion
   * @param {any} suggestions
   */
  getValidProductsSuggestion(suggestions: any, dateOrder?: any, hourOrder?: any): Promise<any> {
    const date: any = dateOrder ? dateOrder : this.tools.getStor("date_order");
    const hour: any = hourOrder ? hourOrder : this.tools.getStor("hour_order");
    const pos: any = this.tools.getStor("point_of_sale");

    const sm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
    const params: any = {
      suggestions: suggestions,
      pos_id: pos.id,
      sm_id: sm.id,
      date_order: date ? moment(date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      hour_order: hour ? moment(hour).format("HH:mm:ss") : moment().add(30, 'seconds').format("HH:mm:ss"),
      id_merchant: this.tools.getStor("id_merchant")
    }
    return new Promise(resolve => {
      this.baseClient.postBase("validProductsSuggestion", params).then(products => {
        if (products && products.code < 0 || products.list && products.list.length == 0) {
          resolve([]);
        }
        else {
          // init le stock
          this.parsebasketProd(products).then(parsedProds => {
            let prods = this.setValidProductStock(parsedProds.products, suggestions);
            resolve(prods);
          });
        }
      });
    });
  }

  /**
   * @description set Products Suggestion
   * @param {any} suggestions
   */
  setValidProductStock(parsedProds: any, sugge: any) {
    let suggestions = cloneDeep(sugge);
    if ((parsedProds && parsedProds.length > 0)) {
      parsedProds.forEach((element: any) => {
        if ((!element.stock || element.stock && element.stock.count && element.stock.count > 0) && element.product_type < 2) {
          if (suggestions && suggestions.length > 0) {
            suggestions.forEach((ele: any) => {
              if (ele && ele.products_to_suggest && ele.products_to_suggest.length > 0) {
                ele.products_to_suggest.forEach((el: any) => {
                  if (element.id == el) {
                    if (!ele.products_exist_suggestions) {
                      ele.products_exist_suggestions = [];
                    }
                    if (element.product_type < 2) {
                      element = cloneDeep(element);
                      element.suggestion_id = ele.id;
                      ele.products_exist_suggestions.push(element);
                    }
                  }
                });
              }
            });
          }
        }
      });
    }

    let array: any = [];
    if (suggestions && suggestions.length > 0) {
      suggestions.forEach((ele: any) => {
        if (ele && ele.products_exist_suggestions && ele.products_exist_suggestions.length > 0) {
          array.push(ele);
        }
      })
    }


    if (array && array.length > 0) {
      array.forEach((ele: any) => {
        let group: any = []
        let result = []
        if (ele && ele.products_exist_suggestions && ele.products_exist_suggestions.length > 0) {
          ele.products_exist_suggestions.forEach((element: any) => {
            !group['rub_' + element.rubric.id] ? group['rub_' + element.rubric.id] = [element] :
              group['rub_' + element.rubric.id].push(element)
          });

          // //group by rubrics
          result = Object.keys(group).map(key => ({
            rubric_name: group[key][0].rubric.name,
            rubric_id: group[key][0].rubric.id,
            products: group[key].sort(() => Math.random() - 0.5)
          }))
          ele.products_exist_suggestions_list = result
          ele.products_exist_suggestions = ele.products_exist_suggestions.sort(() => Math.random() - 0.5);
        }
      })
    }
    return array;
  }

  getFormulesAuto(product: any, merchantClient?: any, categories?: any, dateOrder?: any, hourOrder?: any) {
    this.setObserLoaderFormulePSuggested(true);
    return new Promise(resolve => {
      const date: any = dateOrder ? dateOrder : this.tools.getStor("date_order");
      const hour: any = hourOrder ? hourOrder : this.tools.getStor("hour_order");
      const pos: any = this.tools.getStor("point_of_sale");

      const sm: any = this.tools.getStor(SalemethodService.TAG_STORAGE);
      let params: any = {
        id_product: product.id,
        pos_id: pos.id,
        sm_id: sm.id,
        date_order: date ? moment(date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        hour_order: hour ? moment(hour).format("HH:mm:ss") : moment().add(30, 'seconds').format("HH:mm:ss"),
        id_merchant: this.tools.getStor("id_merchant")
      }
      params.price_period_date = params.date_order + ' ' + params.hour_order;

      // Récupération des suggestions de formules
      this.baseClient.postBaseApi('formules_suggestions', params).then(products => {

        // console.log("formules_suggestions");
        // console.log(products);

        if (products.list && products.list.length > 0) {
          this.parsebasketProd(products).then(parsedProds => {
            // affichage formule sans stock
            let newparsedProds: any = []
            if (parsedProds.products && parsedProds.products.length > 0) {
              parsedProds.products.forEach((element: any) => {
                if (!element.stock || (element.stock && element.stock.count > 0)) {
                  newparsedProds.push(element);
                }
              });

              parsedProds.products = newparsedProds;

            }
            resolve(parsedProds);

            if (newparsedProds && newparsedProds.length > 0) {
              this.openSuggestionsFormulesProductsDial(product, parsedProds, merchantClient, categories);
            }

          })
        } else {
          resolve(null);
          this.setObserLoaderFormulePSuggested(false);
        }
      });

    })


  }

  /**
   * @description Ouvre la popup des formules à suggerer
   * @param {any} suggestions
   */
  openSuggestionsFormulesProductsDial(product: any, suggestionFormules: any, merchantClient?: any, categories?: any) {


    const myConf = new MatDialogConfig();
    myConf.data = {
      suggestionFormules: suggestionFormules.products,
      merchantClient: merchantClient,
      prodselected: product,
      categories: categories
    };

    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "780px", myConf.height = "100%");

    const myDial = this.dialog.open(FormulesSuggestionsComponent, myConf);

    myDial.disableClose = true;

    myDial.afterClosed().subscribe((result) => {

      // loader and close dial
      if (!result) {
        this.checkProductsSuggestions(product, merchantClient);
        result = "data";
      }

      this.setObserLoaderFormulePSuggested(false, result);
    });
  }

  getNewProduct(date_prod: any) {
    let now = moment().subtract(7, 'days')
    now.format("YYYY-MM-DD");
    return moment(date_prod).format("YYYY-MM-DD") > now.format("YYYY-MM-DD") ? true : false;
  }
}
